<template>
  <div>
    <ul class="list-unstyled header-gallery" v-if="images">
      <li @click="showSlides()">
        <ArtworkImage :image="image" version="400" v-if="image" />
      </li>
      <li>{{ image.copyright }}</li>
      <Pagination
        v-model="current"
        :click-handler="onUpdatePage"
        :total="images.length"
        :perPage="1"
        :containerClass="'pagination-images'"
        v-slot:default="{ pagination }"
      >
        <MovementSlidesModal
          :image="image"
          :next="pagination.nextPage"
          :previous="pagination.prevPage"
          :is-first="pagination.firstPageSelected"
          :is-last="pagination.lastPageSelected"
        />
      </Pagination>
    </ul>
  </div>
</template>
<script>
import ArtworkImage from './ArtworkImage.vue';
import Pagination from './Pagination.vue';
import MovementSlidesModal from './MovementSlidesModal.vue';

export default {
  name: 'MovementImages',
  props: {
    images: Array,
  },
  components: {
    ArtworkImage,
    Pagination,
    MovementSlidesModal,
  },
  computed: {
    image() {
      return this.images[this.current - 1];
    },
  },
  methods: {
    showSlides() {
      this.$root.$emit('bv::show::modal', 'slidesModal');
    },
    onUpdatePage(page) {
      this.current = page;
    },
  },
  data() {
    return {
      current: 1,
    };
  },
};
</script>
